// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import _ from 'lodash';
import DateFNS from 'date-fns';
import DateFNSPT from 'date-fns/locale/pt';
// local
import t from 'app/lib/i18n';
import { formatNumber, fromUTC } from 'app/lib/helper';
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';

class ReportPatient extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;

    renderTable(data, onClickSave) {
        const { dateFrom, dateTo, patient, replacements, totalCylindersQtd, reportPrice, totalCylindersReturned, totalPriceReturned } = data;
        const strPhone = [patient.phone1, patient.phone2, patient.phone3].filter(p => p).join(' / ');
        return (
            <React.Fragment>
                <div className="report">
                    <div className="date">
                        <span className="bold">Período:</span> {dateFrom} à {dateTo}
                    </div>
                    <div className="header">
                        <div className="title">
                            SALVUS ATAS | Relatório de reposição de cilindros e consumo de O<sub>2</sub>
                        </div>
                        <div className="content">
                            <div>
                                Paciente: <span className="bold wrap">{patient.name}</span>
                            </div>
                            <div>
                                Fornecedor: <span className="bold wrap">{patient.supplier.name}</span>
                            </div>
                            <div>
                                Telefone: <span className="bold">{strPhone}</span>
                            </div>
                            <div>
                                Atendimento: <span className="bold">{patient.serviceNumber}</span>
                            </div>
                            <div>
                                Pescrição: <span className="bold">{patient.prescription}L/min</span>
                            </div>
                            <div>
                                CPF: <span className="bold">{patient.cpf}</span>
                            </div>
                            <div>
                                Tipo: <span className="bold">{t(`patient_period_type_${patient.periodType}`)}</span>
                            </div>
                            <div>
                                Plano de Saúde: <span className="bold wrap">{patient.healthInsurence}</span>
                            </div>
                            {patient.rg && (
                                <div>
                                    RG: <span className="bold">{patient.rg}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="body">
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center">SEM</Table.HeaderCell>
                                    <Table.HeaderCell>DATA</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">CILINDROS ENTREGUES</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        VOLUME (M<sup>3</sup>)
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">
                                        VALOR (R$/M<sup>3</sup>)
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">TOTAL (R$)</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.map(replacements, row => {
                                    const key = _.uniqueId('row');
                                    const date = fromUTC(new Date(row.date));
                                    return (
                                        <Table.Row key={key}>
                                            <Table.Cell textAlign="center" className="week">
                                                {DateFNS.format(date, 'ddd', { locale: DateFNSPT })}
                                            </Table.Cell>
                                            <Table.Cell>{DateFNS.format(date, 'DD/MM/YYYY')}</Table.Cell>
                                            <Table.Cell textAlign="center">{row.cylinderQtd}</Table.Cell>
                                            <Table.Cell textAlign="center">{formatNumber(row.volume)}</Table.Cell>
                                            <Table.Cell textAlign="center">{formatNumber(row.volumePrice)}</Table.Cell>
                                            <Table.Cell textAlign="center">{formatNumber(row.totalPrice)}</Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                                <Table.Row>
                                    <Table.Cell colSpan="5">
                                        <span className="italic">CILINDROS DEVOLVIDOS: </span>
                                        <span className="bold">{totalCylindersReturned}</span>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center">{formatNumber(-1 * totalPriceReturned)}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.Cell colSpan="2">TOTAL NO PERÍODO</Table.Cell>
                                    <Table.Cell textAlign="center">{totalCylindersQtd}</Table.Cell>
                                    <Table.Cell />
                                    <Table.Cell />
                                    <Table.Cell textAlign="center">R$ {formatNumber(reportPrice)}</Table.Cell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                </div>
                <Button className="btn-save" onClick={onClickSave}>
                    Salvar PDF
                </Button>
            </React.Fragment>
        );
    }

    render() {
        const { onClickSave, data } = this.props;
        return _.isEmpty(data.replacements) ? this.renderEmpty() : this.renderTable(data, onClickSave);
    }
}

ReportPatient.propTypes = {
    data: PropTypes.object,
    onClickSave: PropTypes.func,
};

export default ReportPatient;
